import React from "react";
import "../style/CallForPapers.css";
import { Cpu, Settings, Building, Zap, Signal, Book, Megaphone } from "lucide-react";
import generalInstructions from "../resources/general_instruction.docx";

function CallForPapers() {
  const handleDownloadInstructions = () => {
    const link = document.createElement("a");
    link.href = generalInstructions;
    link.download = "general_instruction.docx";
    link.click();
  };

  const handleSubmitAbstractClick = (event) => {
    event.preventDefault();

    const gmailWebUrl =
      "https://mail.google.com/mail/?view=cm&fs=1&to=conference@iitm.tech";
    const mailtoUrl = "mailto:conference@iitm.tech";

    const isAndroid = /Android/i.test(navigator.userAgent || "");

    if (isAndroid) {
      // Android: open default mail app via mailto link (no fallback)
      window.location.href = mailtoUrl;
    } else {
      // Desktop and other platforms: open web Gmail compose
      window.open(gmailWebUrl, "_blank");
    }
  };

  const topics = [
    {
      id: 1,
      title: "Computer Science and IT Engineering",
      icon: <Cpu className="topic-icon" />,
      topics: [
        "Robotics & Artificial Intelligence",
        "Computer Architecture and Engineering",
        "Human Computer Interaction",
        "Machine Learning & Information Retrieval",
        "Information Security & Assurance",
        "Grid & High Performance Computing"
      ]
    },
    {
      id: 2,
      title: "Mechanical Engineering",
      icon: <Settings className="topic-icon" />,
      topics: ["Composite Materials", "Advanced Welding Technology", "Micromachining", "CAD/CAM"]
    },
    {
      id: 3,
      title: "Civil Engineering",
      icon: <Building className="topic-icon" />,
      topics: [
        "Structural and Construction Engineering",
        "Geotechnical Engineering",
        "Environmental Engineering and Water Resources Engineering",
        "Remote Sensing and GIS Applications"
      ]
    },
    {
      id: 4,
      title: "Electrical and Electronics Engineering",
      icon: <Zap className="topic-icon" />,
      topics: [
        "Power Electronics & Drives",
        "Soft Computing Techniques in Power Systems",
        "Renewable Energy Sources",
        "Embedded Applications"
      ]
    },
    {
      id: 5,
      title: "Electronics and Communication Engineering",
      icon: <Signal className="topic-icon" />,
      topics: [
        "VLSI Design",
        "Digital Signal & Image Processing",
        "Communication & Networking",
        "Avionics, Nano-science"
      ]
    },
    {
      id: 6,
      title: "Management Studies",
      icon: <Book className="topic-icon" />,
      topics: [
        "Strategic HRM",
        "Present Financial Market Scenarios",
        "Recent trends in Marketing",
        "General Management",
      ]
    }
  ];

  return (
    <div className="call-for-papers">
      <div className="paper-card">
        <h1>Call For Papers</h1>

        <div className="notice">
          Emerging Trends and Innovations in Engineering, Management, and Technology
        </div>

        <div className="submission-info">
          <p>
            The International Conference on Emerging Trends and
            Innovations in Engineering, Management, and Technology
            aims to provide a global platform for academicians,
            researchers and industry professionals to share knowledge
            and research outcomes. The conference will highlight
            advanced models, tools and technologies across engineering
            and management, with an emphasis on cutting-edge innovations,
            sustainable solutions, digital transformation, and
            data-driven decision-making.
          </p>

          <p>
            The event will feature technical sessions with peer-reviewed
            papers, along with invited talks by leading academicians and
            industry experts offering insights into recent global developments.
          </p>

          <p>
            The official language of the conference is English.
          </p>

          {/* <p>Conference proceeding in the hard bound book form with the ISBN number will be released.</p> */}
        </div>

        <div className="action-buttons">
          <button
            type="button"
            className="submit-button"
            onClick={handleSubmitAbstractClick}
            title="You will need to sign in to your Google account to submit your abstract."
          >
            Submit Your Abstract
          </button>

          <button
            type="button"
            className="guidelines-button"
            onClick={handleDownloadInstructions}
            title="Download the general instructions for abstract submission."
          >
            General Instructions for Abstract Submission
          </button>
        </div>
      </div>

      <div className="topics-container">
        <div className="topics-content">
          <h1>Conference Theme</h1>

          <div className="topics-intro">
            <p>
              Researchers, Academicians, Industry Professional and
              Students are invited to submit their original research
              papers.The topics covered by the conference must include, but
              are not limited to, the following areas:
            </p>
          </div>

          <div className="topics-grid">
            {topics.map((topic) => (
              <div key={topic.id} className="topic-card">
                <h2>
                  {topic.icon} Theme {topic.id}: {topic.title}
                </h2>
                <ul className="topics-list">
                  {topic.topics.map((item, index) => (
                    <li key={index}>
                      <span className="bullet">•</span>
                      <span className="topic-text">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="other-domains-note">
            <div className="other-domains-box">
              <span className="note-marker" aria-label="Note" role="img">
                <Megaphone size={20} />
              </span>
              <span className="topic-text">
                General Management for The research paper from other domains: English, Mathematics, Physics and Chemistry are also invited.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CallForPapers;
